<template>
  <b-modal
    id="subcontractorprofile-modal"
    ref="modal"
    :title="title"
    @hidden="onClose"
    @show="onShow"
    size="lg"
  >
    <ValidationObserver ref="profileForm" tag="form" @submit.prevent="onSubmit" id="profileForm">
      <div class="row">
        <div class="col-lg-6">
          <template v-if="isEdited === false">
            <div class="section-title">Dane Konta:</div>
            <b-form-group
              label-cols-lg="3"
              label="Adres email:"
              label-for="email"
              label-align-lg="right"
            >
              <ValidationProvider name="email" rules="required|email" v-slot="validationContext">
                <b-form-input
                  id="email"
                  v-model="form.email"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              label-cols-lg="3"
              label="Hasło:"
              label-for="password"
              label-align-lg="right"
            >
              <ValidationProvider name="password" rules="required|min:8" v-slot="validationContext">
                <b-form-input
                  id="password"
                  v-model="form.password"
                  type="password"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            <b-form-group label-cols-lg="3">
              <b-form-checkbox
                id="notification"
                v-model="form.notification"
                name="notification"
                value="1"
                unchecked-value="0"
              >Wyślij e-mail z danymi do logowania</b-form-checkbox>
            </b-form-group>
          </template>
          <div class="section-title">Dane Profilu:</div>
          <b-form-group
            label-cols-lg="3"
            label="Imię:"
            label-for="firstname"
            label-align-lg="right"
          >
            <ValidationProvider
              name="firstname"
              rules="required|max:191"
              v-slot="validationContext"
            >
              <b-form-input
                id="firstname"
                v-model="form.firstname"
                type="text"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-lg="3"
            label="Nazwisko:"
            label-for="lastname"
            label-align-lg="right"
          >
            <ValidationProvider name="lastname" rules="required|max:191" v-slot="validationContext">
              <b-form-input
                id="lastname"
                v-model="form.lastname"
                type="text"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group label-cols-lg="3" label="Telefon:" label-for="phone" label-align-lg="right">
            <ValidationProvider name="phone" rules="max:24" v-slot="validationContext">
              <b-form-input
                id="phone"
                v-model="form.phone"
                type="text"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <div class="section-title">Informacje:</div>
          <b-form-group>
            <b-form-checkbox
              id="self_employment"
              name="self_employment"
              value="1"
              unchecked-value="0"
              v-model="form.self_employment"
            >Samozatrudnienie</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              id="insurance"
              name="insurance"
              value="1"
              unchecked-value="0"
              v-model="form.insurance"
            >Ubezpieczenie</b-form-checkbox>
            <div class="form-inline my-2" v-show="form.insurance.toString() ==='1'">
              <label class="mr-2" for="insurance_valid_to">Ważne do:</label>
              <v-date-picker
              class="datepicker"
                id="insurance_valid_to"
                v-model="form.insurance_valid_to"
                :masks="{ input: 'YYYY-MM-DD' }"
                :popover="{ placement: 'bottom', visibility: 'click',   }"
              />
            </div>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              id="exemption_certificate"
              name="exemption_certificate"
              value="1"
              unchecked-value="0"
              v-model="form.exemption_certificate"
            >Zwolnienie z podatku budowlanego</b-form-checkbox>
            <div class="form-inline my-2" v-show="form.exemption_certificate.toString() === '1'">
              <label class="mr-2" for="exemption_certificate_valid_to">Ważne do:</label>
              <v-date-picker
              class="datepicker"
                id="exemption_certificate_valid_to"
                v-model="form.exemption_certificate_valid_to"
                :masks="{ input: 'YYYY-MM-DD' }"
                :popover="{ placement: 'bottom', visibility: 'click',   }"
              />
            </div>
          </b-form-group>
          <div class="mb-2 font-weight-bold">Wybierz stanowiska: </div>
          <ValidationProvider name="positions" rules="required" v-slot="validationContext">
            <b-form-checkbox-group
              name="positions"
              v-model="form.positions"
              :options="translatedPositions"
              value-field="id"
              text-field="name"
              class="checkbox-group-stacked"
              stacked
            ></b-form-checkbox-group>
            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >You must select at least one item</b-form-invalid-feedback>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="profileForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import SubcontractorsService from "@/services/subcontractors.service";
import {changePositionName} from "@/utils/index";
import dayjs from "dayjs";


const subcontractorForm = {
  firstname: "",
  lastname: "",
  phone: "",
  email: "",
  notification: "1",
  password: "",
  self_employment: "0",
  insurance: "0",
  insurance_valid_to: null,
  exemption_certificate: "0",
  exemption_certificate_valid_to: null,
  positions: []
};
export default {
  name: "ModalSubcontractorProfile",
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters("app", ["positions"]),

    title() {
      return this.$_.isEmpty(this.user) === false
        ? "Edytuj podwykonawce: " + this.user.email
        : "Dodaj nowego podwykonawce";
    },
    isEdited() {
      return this.$_.isEmpty(this.user) === false;
    },
    statepositions() {
      return this.form.positions > 0;
    },
    translatedPositions() {
      return this.positions.map(function (pos) {
        return {
          ...pos,
          name: changePositionName(pos)
        };
      });
    }

  },
  data() {
    return {
      dateFormat: navigator.language,
      form: Object.assign({}, subcontractorForm)
    };
  },
  methods: {
    changePositionName,
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      if (this.isEdited) {
        this.form.notification = 0;
        this.form.positions = [];
        this.$_.each(this.user, (value, key) => {
          if(value && (key === 'insurance_valid_to' || key === 'exemption_certificate_valid_to')){
            this.form[key] = dayjs(value).toDate();
          }else if (key !== "positions") this.form[key] = value;
        });
        this.$_.each(this.user.positions, item => {
          this.form.positions.push(item.id);
        });
      }
    },
    onClose() {
      this.$_.each(this.form, (value, key) => {
        this.form[key] = subcontractorForm[key];
      });
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.profileForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        if (this.isEdited) {
          //-- EDITED
          SubcontractorsService.update(this.user.id, this.form)
            .then(data => {
              this.$_.each(data, (v, k) => {
                this.user[k] = v;
              });
              this.$nextTick(() => {
                this.$bvModal.hide("subcontractorprofile-modal");
              });
            })
            .catch(error => {
              this.$refs.profileForm.setErrors(error.response.data.fields);
            });
        } else {
          //-- CREATE NEW
          SubcontractorsService.create(this.form)
            .then(data => {
              this.$emit("onSubmit", data);
              this.$nextTick(() => {
                this.$bvModal.hide("subcontractorprofile-modal");
              });
            })
            .catch(error => {
              this.$refs.profileForm.setErrors(error.response.data.fields);
            });
        }
      });
    },
  }
};
</script>
